import React from 'react';
import Text from '@deprecated-ui/common/Text';
import Flex from '@deprecated-ui/common/Flex';
import Button from '@deprecated-ui/common/Button';
import Input from '@deprecated-ui/common/Input';
import color from '@deprecated-ui/_style/color';
import { IDataScreenerLoad } from 'features/screener/types';
import screenerSlice, { screenerSelectors } from 'features/screener/slice';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';

const SFlex = styled(Flex)`
  border: 1px solid ${color.gainsboro};
  border-bottom: none;
  background: ${color.light};
  padding: 20px;
`;

const SInput = styled(Input)`
  border: none;
  && input {
    color: ${color.highempahis}
  }
  && input:disabled {
    background: #FAFAFA;
  }
  .ant-input-group-addon {
    background: ${color.whisper};
  }
`;

const ScreenerLabel = ({ data }: { data: IDataScreenerLoad }) => {
  const {
    actions: { setIsFormActive, setIsFormEditMode },
  } = screenerSlice;

  const {
    screenerUtils: { isFormEditMode },
  } = useSelector(screenerSelectors);
  const dispatch = useDispatch();

  const onEditScreener = () => {
    dispatch(setIsFormActive(true));
    dispatch(setIsFormEditMode(true));
  };

  return (
    !isFormEditMode && (
      <SFlex justify="space-between" width="100%">
        <SInput
          key="input"
          width="calc(100% - 130px)"
          // prettier-ignore
          addonBefore={(
            <Text weight="700" family="bold">
              Screen Name
            </Text>
          )}
          name="screenName"
          // @ts-expect-error
          mr="12px"
          disabled
          value={data?.screen_name}
        />
        {/* @ts-expect-error */}
        <Button type="primary" p="4px 10px" onClick={onEditScreener}>
          Edit Screener
        </Button>
      </SFlex>
    )
  );
};

export default ScreenerLabel;
